import { useState } from 'react';
import '../styles/createBlog.css';
import { axiosInstance } from '../lib/axio';
import Editor from './Editor';



const CreateBlog = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' }); // success or error message



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loading indicator
    setMessage({ text: '', type: '' }); // Reset previous messages

    const formData = new FormData();
    formData.append('title', title);
    formData.append('content', content);
    formData.append('image', image);


    try {
      await axiosInstance.post('/blogs/create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setLoading(false); // Hide loading indicator
      setMessage({
        text: 'Blog created successfully!',
        type: 'success', // success message
      });

      // Optionally reset form fields after successful submission
      setTitle('');
      setContent('');
      setImage(null);
      setTimeout(() => setMessage({ text: '', type: '' }), 1500); // Clear message after 5 seconds
    } catch (err) {
      setLoading(false); // Hide loading indicator
      setMessage({
        text: 'Error creating blog. Please try again later.',
        type: 'error', // error message
      });
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-full mx-auto bg-white shadow-md rounded-md p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Blog</h1>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700">Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Content</label>
            {/* <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              rows="6"
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            /> */}
            <Editor content={content} onUpdate={setContent} />
          </div>
          <div>
            <label className="block  text-sm font-medium text-gray-700">Image</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setImage(e.target.files[0])}
              className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
              required
            />
            {loading && <p className="text-sm text-indigo-500 mt-2">Uploading image...</p>}
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${loading ? 'bg-indigo-300' : 'bg-indigo-600 hover:bg-indigo-700'
              } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
          >
            {loading ? 'Creating...' : 'Create Blog'}
          </button>
        </form>
        {message.text && (
          <div className={`message ${message.type}`}>
            {message.text}
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateBlog;
